<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-md-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Search</h5>
          </div>

          <div
            class="ibox-content ibox-heading"
          >Search for interactions. Toggle advanced seach to do an advanced search</div>

          <div class="ibox-content">
            <el-form ref="form" v-on:submit.native.prevent="handleSimpleSearch">
              <div class="simple" v-if="!isAdvancedSearch">
                <div class="input-group">
                  <el-input
                    @keyup.enter.native="handleSimpleSearch"
                    v-model="currentSearchTerm"
                    placeholder="Search...."
                    name="search"
                  ></el-input>
                  <div class="input-group-btn">
                    <el-button type="primary" @click="handleSimpleSearch" plain>Search</el-button>
                  </div>
                </div>
              </div>

              <div class="advanced" v-if="isAdvancedSearch">
                <advanced-search-form
                  :search-fields="searchFields"
                  @onSearch="handleAdvancedSearch"
                ></advanced-search-form>
              </div>

              <el-form-item>
                <el-switch
                  class="pull-right"
                  style="display: block; padding-top: 10px;"
                  v-model="isAdvancedSearch"
                  active-color="#683090"
                  inactive-color="#683090"
                  active-text="Advanced"
                  inactive-text="Simple"
                ></el-switch>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div :class="{'fixed-container': true}">
          <div class="ibox">
            <div class="ibox-title" :style="{'border-top': `2px solid #ee2465`}">
              <h5>
                <span v-if="!searching">{{ searchCount.toLocaleString() }} results found.</span>
                <span v-if="searching">Searching...</span>
              </h5>

              <div class="ibox-tools">
                <el-tooltip
                  v-if="searchCount > 0"
                  content="Export to Excel"
                  effect="dark"
                  placement="bottom"
                >
                  <el-button
                    size="small"
                    class="ibox-tool-btn"
                    type="primary"
                    @click="toggleDownload"
                    plain
                  >
                    <i class="fa fa-download"></i>
                  </el-button>
                </el-tooltip>
              </div>

              <div v-if="searchCount > 0 && showPanelDownload" class="panel-download">
                <el-input
                  placeholder="File name"
                  size="mini"
                  style="margin: 5px auto"
                  v-model="filename"
                >
                  <i
                    v-show="!!filename"
                    class="fa fa-times el-input__icon"
                    slot="prefix"
                    @click="clearFileNameInput"
                  ></i>
                  <i v-show="!filename" slot="prefix" class="el-icon-download el-input__icon"></i>
                  <el-button
                    :disabled="filename.length < 1 "
                    slot="append"
                    icon="fa fa-download"
                    @click="exportToFile(filename)"
                  />
                </el-input>
              </div>
            </div>

            <div class="ibox-content ibox-heading">Interactions search results</div>

            <div class="ibox-content content-style" style="overflow-y: hidden;">
              <VuePerfectScrollbar
                class="ibox-content content-style"
                :ref="'content'"
                :settings="scrollBarSettings"
              >
                <div
                  v-for="interaction in searchResults"
                  :key="interaction.id"
                  class="search-results"
                >
                  <div class="search-result">
                    <interaction :interaction="interaction"></interaction>
                  </div>
                </div>
              </VuePerfectScrollbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Interaction from './Interaction';
import AdvancedSearchForm from '../search/AdvancedSearchForm';

export default {
  name: 'SearchResults',
  components: {
    Interaction,
    AdvancedSearchForm,
    VuePerfectScrollbar,
  },
  data: () => ({
    currentSearchTerm: '',
    isAdvancedSearch: false,
    hasSearched: false,
    scrollBarSettings: {
      suppressScrollX: true,
    },
    showPanelDownload: false,
    filename: '',
  }),
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
    searchResults: {
      type: Array,
      default: () => [],
    },
    searchCount: {
      type: Number,
      default: 0,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleSimpleSearch() {
      this.$emit('onSimpleSearch', { searchTerm: this.currentSearchTerm });
      this.hasSearched = true;
    },

    handleAdvancedSearch(event) {
      this.$emit('onAdvancedSearch', event);
      this.hasSearched = true;
    },
    exportToFile(filename) {
      this.$emit('exportToFile', filename);
      this.clearFileNameInput();
    },
    toggleDownload() {
      this.showPanelDownload = !this.showPanelDownload;
    },
    clearFileNameInput() {
      this.filename = '';
    },
  },

  mounted() {
    if (this.searchTerm) {
      this.currentSearchTerm = this.searchTerm;
      this.hasSearched = true;
    }
  },

  watch: {
    searchTerm(term, oldVal) {
      if (term && term !== oldVal) this.currentSearchTerm = this.searchTerm;
    },
  },
};
</script>

<style scoped>
.search-form {
  margin-top: 30px;
}

.content-style {
  padding: 15px 10px 20px 10px;
  border-width: 0px 0;
}
</style>



// WEBPACK FOOTER //
// SearchResults.vue?565f723f